<template>
    <div class="page-banner-setting-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">積分管理</div>
            <div class="breadcrumb-item">贈送類型設置-修改</div>
        </div>
        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="18" push="5">
                        <Form :label-width="150">
                            <Row>
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>充值渠道</span>
                                        </div>
                                        <Select size="small" style="width: 120px;" placeholder="選擇充值渠道" v-model="form.pid">
                                            <Option :value="1">線上充值</Option>
                                            <Option :value="2">門店充值</Option>
                                        </Select>
                                    </FormItem>
									<FormItem>
									    <div slot="label" class="form-label">
									        <em class="red">* </em>
									        <span>贈送類型</span>
									    </div>
                                        <Select size="small" style="width: 120px;" placeholder="選擇贈送類型" v-model="form.type">
                                            <Option :value="1">積分</Option>
                                            <Option :value="2">集金幣</Option>
                                        </Select>
									</FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style1" @click="handleCheckForm">確認</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                isSubmiting: false,
                form: {
                    id: '',
                    pid: '',
                    type: '',
					created_at: ''
                }
            };
        },
        mounted()
        {
            this.pageParam = this.$route.query;
			if(this.pageParam.id != undefined) {
				this.getDetail();
			}
        },
        methods: {
            handleBack()
            {
                this.$router.go(-1);
            },
            getDetail()
            {
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.creditTypeOption,
                    method: 'get',
                    data: {
                        id:  this.pageParam.id
                    },
                }).then((res) =>{
                    this.isSubmiting = false;
                    if (res.code == 0){
                        let resData = res.data[0];
                        this.form = {
                            id: resData.id,
                            pid: resData.pid,
                            type: resData.type,
                            created_at: resData.created_at,
                        };
                    }
                }).catch((err) =>{
                    this.isSubmiting = false;
                });
            },
            handleCheckForm()
            {
                let form = this.form;
                if (form.pid === '')
                {
                    this.$Utils.showTipInfo('請輸入積分');
                    return;
                } else if (form.type === '')
                {
                    this.$Utils.showTipInfo('請輸入價格');
                    return;
                }
				
				this.handleSubmit();
            },
            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;
				
				this.$Rq.requestAuth({
				    url: this.$Api.creditTypeOptionEdit,
				    method: 'post',
				    data: {
				        online: form.pid,
				        dataType: form.type,
				    }
				}).then((res) => {
				    this.isSubmiting = false;
				    if (res.code == 0) {
				        this.$Utils.showSuccess(res.msg);
				    } else {
				        this.$Utils.showTipInfo(res.msg);
				    }
				}).catch((err) =>{
				    this.isSubmiting = false;
				});
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "creditTypeSettingEdit.scss";
</style>